import React, { useState, useEffect } from "react";
import { Center, useToast } from "@chakra-ui/react";
import axios from "axios";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";

const MEListTable = () => {
  const toast = useToast();
  const navigate = useNavigate(); // Initialize navigate
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [voucherDetails, setVoucherDetails] = useState([]);
  const [loadingVoucher, setLoadingVoucher] = useState(false);

  const cmpId = sessionStorage.getItem("cmp_id");

  useEffect(() => {
    const fetchVoucherDetails = async () => {
      setLoadingVoucher(true);
      try {
        const response = await axios.post(
          `${ACCOUNTS_URL}/multi_voucher/list_all_multi_voucher.php`,
          {
            cmp_id: cmpId,
          }
        );
        console.log("====================================");
        console.log(response);
        console.log("====================================");

        if (response.data.success && Array.isArray(response.data.data)) {
          setVoucherDetails(response.data.data);
        } else {
          setVoucherDetails([]);
          toast({
            title: "Error",
            description: response.data.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        setVoucherDetails([]);
        toast({
          title: "Error",
          description: "Error fetching voucher details.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoadingVoucher(false);
      }
    };

    fetchVoucherDetails();
  }, [cmpId, toast]);

  const filteredVouchers = voucherDetails.filter((voucher) => {
    const ledgerNames = voucher.entries
      .map((entry) => entry.ledger_name)
      .join(" ")
      .toLowerCase();
    return ledgerNames.includes(searchTerm.toLowerCase());
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredVouchers.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredVouchers.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle Voucher Deletion
  const handleDeleteVoucher = async (voucherNo) => {
    const p = {
      cmp_id: cmpId,
      voucher_no: voucherNo,
    };

    try {
      const response = await axios.post(
        `${ACCOUNTS_URL}/multi_voucher/delete_multi_voucher.php`,
        p,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("====================================");
      console.log(response);
      console.log("====================================");

      if (response.data.success) {
        toast({
          title: "Success",
          description: "Voucher deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        // Remove the voucher from state after successful deletion
        setVoucherDetails((prev) =>
          prev.filter((v) => v.voucher_no !== voucherNo)
        );
      } else {
        toast({
          title: "Error",
          description: response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Error deleting voucher.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Navigate to edit page
  const handleEditVoucher = (voucherNo) => {
    navigate(`/voucher/multientry/edit/${voucherNo}`);
  };

  return (
    <Box borderWidth="1px" mt={3} borderRadius="20px" bg="white">
      <Flex
        justify="space-between"
        align="center"
        borderTopWidth="1px"
        mb={1}
        p={3}
      >
        <Flex align="center">
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>
        <Flex align="center">
          <Input
            placeholder="Search by Ledger..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            mr={3}
          />
        </Flex>
      </Flex>

      <Box
        style={{ overflowX: "auto" }}
        // w={{ base: "367px", md: "100%" }}
        width="100%"
        className={styles.Table}
      >
        {loadingVoucher ? (
          <Spinner />
        ) : (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
          >
            <Thead>
              <Tr>
                <Th>Voucher No</Th>
                <Th>Date</Th>
                <Th>Particulars</Th>
                <Th>
                  <Box textAlign="center">Debit</Box>
                </Th>
                <Th>
                  <Box textAlign="center">Credit</Box>
                </Th>
                <Th>
                  <Box textAlign="center">Actions</Box>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((voucher) => (
                  <React.Fragment key={voucher.voucher_no}>
                    {/* Render each voucher's entries */}
                    {voucher.entries.map((entry, index) => (
                      <Tr key={index}>
                        {/* Voucher No will be displayed once */}
                        <Td>{index === 0 ? voucher.voucher_no : ""}</Td>
                        <Td>{index === 0 ? voucher.date.split(" ")[0] : ""}</Td>
                        <Td>{entry.ledger_name}</Td>
                        <Td textAlign="right">
                          <Box textAlign="right">{entry.debit}</Box>
                        </Td>
                        <Td textAlign="right">
                          <Box textAlign="right">{entry.credit}</Box>
                        </Td>
                        <Td>
                          <Box textAlign="center">
                            {/* Show Edit Button for the first entry in the voucher */}
                            {index === 0 && (
                              <Button
                                colorScheme="blue"
                                size="sm"
                                onClick={() =>
                                  handleEditVoucher(voucher.voucher_no)
                                }
                                mr={2}
                              >
                                Edit
                              </Button>
                            )}
                            {/* Show Delete Button only for the first entry in the voucher */}
                            {index === 0 && (
                              <Button
                                colorScheme="red"
                                size="sm"
                                onClick={() =>
                                  handleDeleteVoucher(voucher.voucher_no)
                                }
                              >
                                Delete
                              </Button>
                            )}
                          </Box>
                        </Td>
                      </Tr>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                <Tr>
                  <Td colSpan={6} textAlign="center">
                    No vouchers found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        )}
      </Box>
      <Flex justify="end" borderTopWidth="1px" mt={1} p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="#ff8f00" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default MEListTable;
